module.exports = __webpack_public_path__ + "img/ai4.c0e809c7.png";